module.exports = __webpack_public_path__ + "img/loading.bb1408b8.gif";